import React, { useState } from "react";
import {
  FiCalendar,
  FiClock,
  FiUsers,
  FiUser,
  FiBookOpen,
  FiRefreshCw,
  FiBarChart2,
  FiCheckCircle,
  FiXCircle,
  FiClock as FiClockIcon,
  FiActivity,
  FiVideo,
  FiMonitor,
  FiGrid,
} from "react-icons/fi";
import {
  MdOutlineVideoLibrary,
  MdOutlineSchedule,
  MdOutlinePending,
  MdOutlineCheckCircle,
  MdOutlineCancel,
} from "react-icons/md";
import SessionMangmentTable from "./Table/SessionMangmentTable";
import ViewModal from "./Modal/ViewModal";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSessionList } from "../../Redux/sessionSlice";
import Loader from "../../components/Loader/Loader";
import { toast } from "react-toastify";
import { actionByAdminOnSessionBook } from "../../Redux/communitySlice";
import ConfirmToggleModal from "./Modal/ConfirmToggleModal";

const SessionMangment = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const {
    sessionSlice: { sessions = [], totalSession, loading },
  } = selector ? selector : {};
  const [isSessionModal, setIsSessionModal] = useState(false);
  const [isSessionModalData, setIsSessionModalData] = useState(null);
  const [isToggleModal, setIsToggleModal] = useState(false);
  const [isToggleModalId, setIsToggleModalId] = useState(null);

  const [filter, setFilter] = useState({
    keyword: "",
    startDate: "",
    endDate: "",
    size: 10,
    pageNo: 1,
    disable_type: "",
  });

  const [adminToggleData, setAdminToggleData] = useState({
    isOpen: false,
    data: null,
  });
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const TbaleHeader = [
    { label: "#", sortKey: null },
    { label: "Session Title", sortKey: "title" },
    { label: "Duration", sortKey: null },
    { label: "Expert Name", sortKey: "user.fullName" },
    { label: "Enrollment", sortKey: "enrollments" },
    { label: "Admin Status", sortKey: "isDisableByAdmin" },
    { label: "Created Date", sortKey: "createdAt" },
    { label: "Action", sortKey: null },
  ];

  const handleSort = (key) => {
    setFilter((prev) => {
        const isSameKey = prev.sortBy === key;
        return {
            ...prev,
            sortBy: key,
            sortOrder: isSameKey && prev.sortOrder === "asc" ? "desc" : "asc",
            pageNo: 1
        };
    });
  };

  useEffect(() => {
    dispatch(getSessionList(filter));
  }, [dispatch, filter, isRefresh]);

  const viewAction = (data) => {
    setIsSessionModal(!isSessionModal);
    setIsSessionModalData(data);
  };

  const toggleSessionModal = () => {
    console.log("click for toggle");

    setIsSessionModal(!isSessionModal);
  };

  console.log("isSessionModal__", isSessionModal);

  const handleSubmit = () => {};

  const handlePageClick = (data) => {
    setFilter((p) => ({
      ...p,
      pageNo: data.selected + 1,
    }));
  };

  const handleConfirmToggle = async () => {
    try {
      setIsActionLoading(true);
      const response = await dispatch(
        actionByAdminOnSessionBook({
          id: isToggleModalId._id,
          isDisableByAdmin: isToggleModalId?.isDisableByAdmin ? false : true,
        }),
      );

      if (response?.payload?.code === 200) {
        toast.success("Status updated successfully");
      } else {
        toast.error(response?.payload?.message || "Failed to update status.");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.message || "Oops! Something went wrong. Please try again.",
      );
    } finally {
      setIsActionLoading(false);
      setAdminToggleData({ isOpen: false, data: null });
      setIsRefresh(!isRefresh);
      setIsToggleModal(false);
      setIsToggleModalId(null);
    }
  };

  // Calculate session statistics
  const totalSessions = totalSession || 0;
  const activeSessions =
    sessions?.filter((s) => !s.isDisableByAdmin)?.length || 0;
  const inactiveSessions =
    sessions?.filter((s) => s.isDisableByAdmin)?.length || 0;
  const pendingSessions =
    sessions?.filter((s) => s.status === "pending")?.length || 0;

  // Get session stats for cards
  const statsCards = [
    {
      title: "Total Sessions",
      count: totalSessions,
      icon: FiVideo,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
    },
    // {
    //   title: "Active Sessions",
    //   count: activeSessions,
    //   icon: FiCheckCircle,
    //   color: "from-emerald-500 to-emerald-600",
    //   bgColor: "bg-emerald-50",
    //   textColor: "text-emerald-600"
    // },
    // {
    //   title: "Inactive Sessions",
    //   count: inactiveSessions,
    //   icon: FiXCircle,
    //   color: "from-rose-500 to-rose-600",
    //   bgColor: "bg-rose-50",
    //   textColor: "text-rose-600"
    // },
    // {
    //   title: "Pending Review",
    //   count: pendingSessions,
    //   icon: FiClockIcon,
    //   color: "from-amber-500 to-amber-600",
    //   bgColor: "bg-amber-50",
    //   textColor: "text-amber-600"
    // }
  ];

  const handleToggle = (data) => {
    console.log("toggle data", data);
    setIsToggleModal(true);
    setIsToggleModalId(data);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Loader loading={loading || isActionLoading} />

      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>

        <div className="relative z-10 px-4 md:px-7 py-4 md:py-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
                <MdOutlineVideoLibrary className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont">
                  Session Management
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage and moderate all sessions on the platform
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <span className="px-3 py-1 text-xs text-white bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="inline w-3 h-3 mr-1" />
                {new Date().toLocaleDateString()}
              </span>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-3 mt-4 sm:grid-cols-4 md:gap-4">
            {statsCards.map((card, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">
                      {card.title}
                    </p>
                    <p className="text-lg font-bold text-white md:text-2xl">
                      {card.count}
                    </p>
                  </div>
                  <div
                    className={`p-2 rounded-lg bg-gradient-to-br ${card.color} bg-opacity-30`}
                  >
                    <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Table Section */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-3 md:p-4">
            <SessionMangmentTable
              TbaleName={`Overall Session (${totalSessions})`}
              TbaleHeader={TbaleHeader}
              TbaleData={sessions}
              viewAction={viewAction}
              total={totalSessions}
              handlePageClick={handlePageClick}
              setFilter={setFilter}
              filter={filter}
              setAdminToggleData={setAdminToggleData}
              currentSortKey={filter.sortBy}
              currentSortOrder={filter.sortOrder}
              onSort={handleSort}
              toggleAction={handleToggle}
            />
          </div>
        </div>
      </section>

      {/* Modals */}
      {isSessionModal && (
        <ViewModal
          onCancel={toggleSessionModal}
          onSubmit={handleSubmit}
          inputValue={isSessionModalData}
        />
      )}

      {isToggleModal && (
        <ConfirmToggleModal
          isOpen={isToggleModal}
          isDisable={isToggleModalId?.isDisableByAdmin}
          onCancel={() => setIsToggleModal(false)}
          onConfirm={handleConfirmToggle}
        />
      )}
    </div>
  );
};

export default SessionMangment;
